import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ThemeProvider } from './context/ThemeContext';

import Navbar from './components/Navbar'; 

import Home from './pages/Home';
import About from './pages/About';
import Portfolio from './pages/Portfolio';
import Pricing from './pages/Pricing';
import Services from './pages/Services';
// import Blog from './pages/Blog';
import Contact from './pages/Contact';
import Admin from './pages/Admin'; 

function App() {
  return (
    <ThemeProvider>
      <Router>
        <Navbar /> 
        
        <main style={{ minHeight: '80vh', width: '100%', margin: 0, padding: 0 }}>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/services" element={<Services />} />
            <Route path="/portfolio" element={<Portfolio />} />
            <Route path="/pricing" element={<Pricing />} />
            {/* <Route path="/blog" element={<Blog />} /> */}
            <Route path="/contact" element={<Contact />} />
            
            <Route path="/admin" element={<Admin />} />
          </Routes>
        </main>
      </Router>
    </ThemeProvider>
  );
}

export default App;